import { create } from 'zustand';
import type { SupportedLanguage } from '@/types/tenant.types';
import { getAppLanguage } from '@/i18n/appLanguage';

/**
 * Localization store — mirrors Flutter's LocalizationProvider.
 * Tracks current language and supported languages.
 */

interface LocalizationState {
  currentLanguage: string;
  supportedLanguages: SupportedLanguage[];

  setLanguage: (code: string) => void;
  setSupportedLanguages: (languages: SupportedLanguage[]) => void;
}

export const useLocalizationStore = create<LocalizationState>((set) => ({
  // Flutter LocalizationProvider: Locale(LocalDataService.getAppLanguage())
  currentLanguage: getAppLanguage(),
  supportedLanguages: [],

  setLanguage: (code) => {
    const oldLang = getAppLanguage();
    localStorage.setItem('oldLanguage', oldLang);
    localStorage.setItem('appLanguage', code);
    set({ currentLanguage: code });
  },

  setSupportedLanguages: (languages) => set({ supportedLanguages: languages }),
}));
